import {
  accountsBaseUrl,
  cloudBaseUrl,
  docsBaseUrl,
  hubBaseUrl,
  websiteBaseUrl,
} from '../constants/url';

export const paths = {
  accounts: {
    index: accountsBaseUrl ? `${accountsBaseUrl}` : '/',
    success: `${accountsBaseUrl}/success`,
    successClose: `${accountsBaseUrl}/success-close`,
    successManual: `${accountsBaseUrl}/success-manual`,
  },
  auth: {
    connector: `/auth/connector`,
    forgotPassword: `/auth/forgot-password`,
    login: `/auth/login`,
    register: `/auth/register`,
    resetPassword: `/auth/reset-password`,
    verifyEmail: `/auth/verify-email`,
  },
  awsMarketplace:
    'https://aws.amazon.com/marketplace/pp/prodview-lowyuyay5a37s?sr=0-1&applicationId=AWSMPContessa',
  bluesky: 'https://bsky.app/profile/cloudquery.bsky.social',
  bookCall: 'https://calendly.com/cloudquery-michal/call-with-cloudquery',
  careers: 'https://apply.workable.com/cloudquery',
  cloud: {
    createTeam: `${cloudBaseUrl}/create-team`,
    index: cloudBaseUrl ? `${cloudBaseUrl}` : '/',
    notFound: `${cloudBaseUrl}/404`,
    packages: {
      addon: {
        index: `${cloudBaseUrl}/teams/[team]/packages/addons/[type]/[addon]`,
        version: {
          index: `${cloudBaseUrl}/teams/[team]/packages/addons/[type]/[addon]/versions/[version]`,
        },
        versions: `${cloudBaseUrl}/teams/[team]/packages/addons/[type]/[addon]/versions`,
      },
      addons: `${cloudBaseUrl}/teams/[team]/packages/addons`,
      createAddon: `${cloudBaseUrl}/teams/[team]/packages/create-addon`,
      createPlugin: `${cloudBaseUrl}/teams/[team]/packages/create-plugin`,
      plugin: {
        index: `${cloudBaseUrl}/teams/[team]/packages/plugins/[kind]/[plugin]`,
        version: {
          index: `${cloudBaseUrl}/teams/[team]/packages/plugins/[kind]/[plugin]/versions/[version]`,
        },
        versions: `${cloudBaseUrl}/teams/[team]/packages/plugins/[kind]/[plugin]/versions`,
      },
      plugins: `${cloudBaseUrl}/teams/[team]/packages/plugins`,
    },
    team: {
      apiKeys: `${cloudBaseUrl}/teams/[team]/api-keys`,
      billing: `${cloudBaseUrl}/teams/[team]/billing`,
      destination: {
        create: `${cloudBaseUrl}/teams/[team]/destinations/create`,
        detail: {
          edit: `${cloudBaseUrl}/teams/[team]/destinations/[name]/update`,
          index: `${cloudBaseUrl}/teams/[team]/destinations/[name]`,
        },
        index: `${cloudBaseUrl}/teams/[team]/destinations`,
      },
      index: `${cloudBaseUrl}/teams/[team]`,
      invitations: `${cloudBaseUrl}/teams/[team]/invitations`,
      members: `${cloudBaseUrl}/teams/[team]/members`,
      settings: `${cloudBaseUrl}/teams/[team]/settings`,
      source: {
        create: `${cloudBaseUrl}/teams/[team]/sources/create`,
        detail: {
          edit: `${cloudBaseUrl}/teams/[team]/sources/[name]/update`,
          index: `${cloudBaseUrl}/teams/[team]/sources/[name]`,
        },
        index: `${cloudBaseUrl}/teams/[team]/sources`,
      },
      syncs: {
        create: `${cloudBaseUrl}/teams/[team]/syncs/create`,
        index: `${cloudBaseUrl}/teams/[team]/syncs`,
        run: {
          index: `${cloudBaseUrl}/teams/[team]/syncs/[name]/runs/[id]`,
          logs: `${cloudBaseUrl}/teams/[team]/syncs/[name]/runs/[id]/logs`,
        },
        runs: `${cloudBaseUrl}/teams/[team]/syncs/[name]/runs`,
        update: `${cloudBaseUrl}/teams/[team]/syncs/[name]/update`,
      },
      transformer: {
        create: `${cloudBaseUrl}/teams/[team]/transformers/create`,
        detail: {
          edit: `${cloudBaseUrl}/teams/[team]/transformers/[name]/update`,
          index: `${cloudBaseUrl}/teams/[team]/transformers/[name]`,
        },
        index: `${cloudBaseUrl}/teams/[team]/transformers`,
      },
      usage: {
        index: `${cloudBaseUrl}/teams/[team]/usage`,
        plugin: {
          create: `${cloudBaseUrl}/teams/[team]/usage/[pluginTeam]/[pluginKind]/[pluginName]/limit/create`,
          update: `${cloudBaseUrl}/teams/[team]/usage/[pluginTeam]/[pluginKind]/[pluginName]/limit/update`,
        },
      },
    },
    teamShortLinks: {
      apiKeys: `${cloudBaseUrl}/team-api-keys`,
      billing: `${cloudBaseUrl}/team-billing`,
      destinations: {
        create: `${cloudBaseUrl}/team-destinations/create`,
      },
      invitations: `${cloudBaseUrl}/team-invitations`,
      members: `${cloudBaseUrl}/team-members`,
      settings: `${cloudBaseUrl}/team-settings`,
      sources: {
        create: `${cloudBaseUrl}/team-sources/create`,
      },
      syncs: {
        index: `${cloudBaseUrl}/team-syncs`,
      },
      usage: {
        index: `${cloudBaseUrl}/team-usage`,
      },
    },
    user: {
      index: `${cloudBaseUrl}/user`,
    },
    userSettings: {
      invitations: `${cloudBaseUrl}/user-settings/invitations`,
      settings: `${cloudBaseUrl}/user-settings/settings`,
    },
  },
  community: 'https://community.cloudquery.io',
  contactUs: 'https://cloudquery.typeform.com/to/UrgOydHV?typeform-source=www.cloudquery.io',
  deploymentOverview: 'https://docs.cloudquery.io/docs/deployment/overview',
  docs: {
    alerts: `https://docs.cloudquery.io/alerts`,
    createPlugin: `${docsBaseUrl}/docs/developers/creating-new-plugin`,
    dashboards: `${docsBaseUrl}/docs/core-concepts/dashboards`,
    howToGuides: `${websiteBaseUrl}/blog?tags=Tutorials`,
    index: docsBaseUrl ? `${docsBaseUrl}` : '/',
    plugins: `${docsBaseUrl}/docs/core-concepts/plugins`,
    publishAddon: `${docsBaseUrl}/docs/developers/publishing-an-addon-to-the-hub`,
    publishPlugin: `${docsBaseUrl}/docs/developers/publishing-a-plugin-to-the-hub`,
    quickstart: `${docsBaseUrl}/docs/quickstart/cloudquery-cloud`,
    searchesAndQueries: `${docsBaseUrl}/core-concepts/searches-and-queries`,
    transformations: `${docsBaseUrl}/docs/core-concepts/transformations`,
  },
  documentation: 'https://platform-docs.cloudquery.io',
  github: 'https://github.com/cloudquery/cloudquery',
  githubIssues: 'https://github.com/cloudquery/cloudquery/issues',
  hub: {
    addon: `${hubBaseUrl}/addons/[type]/[team]/[name]`,
    addonDocs: `${hubBaseUrl}/addons/[type]/[team]/[name]/[version]/docs`,
    addonVersion: `${hubBaseUrl}/addons/[type]/[team]/[name]/[version]`,
    addonVersionDynamic: `${hubBaseUrl}/addons-dynamic/[type]/[team]/[name]/[version]`,
    addonVersions: `${hubBaseUrl}/addons/[type]/[team]/[name]/[version]/versions`,
    addons: `${hubBaseUrl}/addons/[type]`,
    exportData: `${hubBaseUrl}/export-data/[source]/[destination]`,
    exportDataPlatformSpecific: `${hubBaseUrl}/export-data/[source]/[destination]/[platform]`,
    plugin: `${hubBaseUrl}/plugins/[kind]/[team]/[name]`,
    pluginDestinations: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/[version]/destinations`,
    pluginDestinationsWithoutVersion: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/destinations`,
    pluginDocs: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/[version]/docs`,
    pluginTable: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/[version]/tables/[table]`,
    pluginTables: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/[version]/tables`,
    pluginVersion: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/[version]`,
    pluginVersionDynamic: `${hubBaseUrl}/plugins-dynamic/[kind]/[team]/[name]/[version]`,
    pluginVersions: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/[version]/versions`,
    plugins: `${hubBaseUrl}/plugins/[kind]`,
    pluginsSource: `${hubBaseUrl}/plugins/source`,
    reportDetails: `${hubBaseUrl}/reports/[name]`,
    reports: `${hubBaseUrl}/reports`,
  },
  linkedIn: 'https://www.linkedin.com/company/cloudqueryio',
  noAccount: '/no-account',
  onboarding: '/onboarding',
  platform: {
    admin: {
      apiKeys: {
        index: `/admin/api-keys`,
      },
      auditLogs: {
        index: `/admin/audit-logs`,
      },
      customColumns: {
        index: `/admin/custom-columns`,
      },
      featureFlags: {
        index: `/admin/feature-flags`,
      },
      notificationDestinations: {
        index: `/admin/notification-destinations`,
      },
      settings: {
        index: `/admin/settings`,
      },
      sso: {
        index: `/admin/sso`,
      },
      updates: {
        index: `/admin/updates`,
      },
      users: {
        index: `/admin/users`,
      },
    },
    createTeam: `/create-team`,
    index: '/',
    team: {
      assetInventory: {
        index: `/teams/[team]/asset-inventory`,
        syntax: `/teams/[team]/asset-inventory/syntax`,
      },
      index: `/teams/[team]`,
      policies: {
        create: `/teams/[team]/policies/create`,
        detail: `/teams/[team]/policies/[id]`,
        index: `/teams/[team]/policies`,
      },
      reports: {
        index: `/teams/[team]/reports`,
        report: `/teams/[team]/reports/[id]`,
      },
      sqlConsole: {
        index: `/teams/[team]/sql-console`,
      },
      syncs: {
        create: `/teams/[team]/syncs/create`,
        destinations: {
          create: `/teams/[team]/syncs/destinations/create`,
          index: `/teams/[team]/syncs/destinations`,
          syncs: `/teams/[team]/syncs/destinations/[name]/syncs`,
          update: `/teams/[team]/syncs/destinations/[name]/update`,
        },
        index: `/teams/[team]/syncs`,
        runs: {
          index: `/teams/[team]/syncs/[name]/runs`,
        },
        sources: {
          create: `/teams/[team]/syncs/integrations/create`,
          index: `/teams/[team]/syncs/integrations`,
          syncs: `/teams/[team]/syncs/integrations/[name]/syncs`,
          update: `/teams/[team]/syncs/integrations/[name]/update`,
        },
        update: `/teams/[team]/syncs/[name]/update`,
      },
      usage: {
        index: `/teams/[team]/usage`,
      },
    },
    userSettings: {
      index: `/user-settings`,
      invitations: `/user-settings/invitations`,
    },
  },
  platformDocs: {
    importingSourcePlugins: 'https://platform-docs.cloudquery.io/quickstart/importing-integrations',
    privacyPolicy: 'https://www.cloudquery.io/legal/privacy-policy',
    searchSyntax: 'https://platform-docs.cloudquery.io/reference/search-query-syntax',
    sqlConsole: 'https://platform-docs.cloudquery.io/core-concepts/sql-console',
    sso: 'https://platform-docs.cloudquery.io/production-deployment/enabling-single-sign-on-sso',
    termsOfService: 'https://www.cloudquery.io/legal/product-terms-of-service',
  },
  requestDemo: 'https://cloudquery.typeform.com/to/JzYehzzT',
  requestLiveDemo: 'https://cloudquery.typeform.com/to/ZhL79VF7',
  serviceHealth: 'https://status.cloudquery.io/',
  threads: 'https://www.threads.net/@cloudqueryio',
  trustCenter: 'https://app.drata.com/trust/cc9ec5bb-5e31-4fe3-9175-362b3ad96c70',
  website: {
    blog: `${websiteBaseUrl}/blog`,
    blogArticle: `${websiteBaseUrl}/blog/[article]`,
    blogAuthor: `${websiteBaseUrl}/authors/[author]`,
    blogCategory: `${websiteBaseUrl}/blog/category/[category]`,
    caseStudies: `${websiteBaseUrl}/case-studies`,
    caseStudyDunelmCspm: `/blog/dunelm-cloudquery-snowflake-enhance-aws-security`,
    caseStudyHexagon: `/blog/how-hexagon-built-an-infrastructure-data-lake`,
    caseStudyRidgeline: `/blog/ridgeline-enhanced-saved-money-cloud-security-cloudquery`,
    caseStudySkyhawk: `/blog/how-skyhawk-security-powers-their-cyber-security-platform-data-collection-with`,
    caseStudyTempus: `/blog/tempus-multi-cloud-asset-inventory`,
    contactUs: `${websiteBaseUrl}/contact-us`,
    dataCounsil2024: `${websiteBaseUrl}/data-council-2024`,
    download: `${websiteBaseUrl}/download`,
    downloadsType: `${websiteBaseUrl}/downloads/[type]`,
    eventDetails: `${websiteBaseUrl}/events/[type]`,
    events: `${websiteBaseUrl}/events`,
    forDevelopers: `${websiteBaseUrl}/solutions/for-developers`,
    index: websiteBaseUrl ? `${websiteBaseUrl}` : '/',
    industryFinance: `${websiteBaseUrl}/industries/finance`,
    legal: `${websiteBaseUrl}/legal`,
    legalDocument: `${websiteBaseUrl}/legal/[document]`,
    newsletter: `${websiteBaseUrl}/newsletter`,
    partnershipBigQuery: `${websiteBaseUrl}/partnerships/bigquery`,
    partnershipDataBricks: `${websiteBaseUrl}/partnerships/databricks`,
    pricing: `${websiteBaseUrl}/pricing`,
    productsCloudAssetInventory: `${websiteBaseUrl}/products/cloud-asset-inventory`,
    productsDataPipelines: `${websiteBaseUrl}/products/data-pipelines`,
    productsGovernance: `${websiteBaseUrl}/products/governance`,
    productsReports: `${websiteBaseUrl}/products/reports`,
    solutionsCaasm: `${websiteBaseUrl}/solutions/caasm`,
    solutionsCloudAssetManagement: `${websiteBaseUrl}/solutions/cloud-asset-management`,
    solutionsCloudCmdb: `${websiteBaseUrl}/solutions/cloud-cmdb`,
    solutionsCmdbEnrichment: `${websiteBaseUrl}/solutions/cmdb-enrichment`,
    solutionsCspm: `${websiteBaseUrl}/solutions/cspm`,
    solutionsFinOps: `${websiteBaseUrl}/solutions/fin-ops`,
    solutionsPlatformEngineering: `${websiteBaseUrl}/solutions/platform-engineering`,
    solutionsVulnerabilityManagement: `${websiteBaseUrl}/solutions/vulnerability-management`,
    unsubscribe: `${websiteBaseUrl}/unsubscribe/[type]`,
  },
  wistia: {
    assetInventory: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/b56ea2490f3e654a4e922c4d5d8b8cdecc711ace.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/xpqesvfbi1',
    },
    cloudCmdb: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/58f34b17e387aaba8c20bb6fab32c1be.webp??video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/mj228yv5p4',
    },
    cspm: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/d70b1572ba352a103746923dfdc2809a7bf6a6fe.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/807yn10dvo',
    },
    dataPipelines: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/d75e3c9e03e4bb42f0ff75846cd18bc858e71cf3.webp?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/89j9zk9uy0',
    },
    demo: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/a27d055b6d986f27f58c589c296d67aebe8c45c0.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/w2nlvnelvk',
    },
    finOps: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/749d80bac2d770f6d8f985e70a098e40584758e4.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/htqlr4fhzr',
    },
    platformEngineering: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/f3bb0e8f3d8e86f061f3ca5d29059d1d7693fcdf.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/z0vs0trc6j',
    },
    saveFilters: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/d8b033444a4783cb8761053fa12c7e8c9bb536ab.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/2n7enpve62',
    },
    sqlConsole: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/8694bbe3c10af6431cc374148667612d62e75269.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/fixiyi29yp',
    },
  },
  x: 'https://x.com/cloudqueryio',
  youtube: {
    channel: 'https://www.youtube.com/@cloudqueryio',
  },
};
